import { render, staticRenderFns } from "./SourcingList.vue?vue&type=template&id=bb7b99a6&scoped=true"
import script from "./SourcingList.vue?vue&type=script&lang=js"
export * from "./SourcingList.vue?vue&type=script&lang=js"
import style0 from "./SourcingList.vue?vue&type=style&index=0&id=bb7b99a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7b99a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb7b99a6')) {
      api.createRecord('bb7b99a6', component.options)
    } else {
      api.reload('bb7b99a6', component.options)
    }
    module.hot.accept("./SourcingList.vue?vue&type=template&id=bb7b99a6&scoped=true", function () {
      api.rerender('bb7b99a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sourcing/SourcingList.vue"
export default component.exports